import React, { useEffect } from 'react';
import { fetchBingeWorthyListings, bingeWorthyListingsSelector } from '../../../LandingPage/LandingPage.duck';
import { useDispatch, useSelector } from 'react-redux';
import { CarouselSection } from '../../../../components';

const BingeWorthyOriginalsSection = ({ sectionName, description }) => {
  const dispatch = useDispatch();
  const bingeWorthyListings = useSelector(bingeWorthyListingsSelector);

  useEffect(() => {
    dispatch(fetchBingeWorthyListings());
  }, []);

  return bingeWorthyListings?.length ? (
    <CarouselSection
      name={sectionName}
      description={description}
      items={bingeWorthyListings}
    />
  ) : null;
};

export default BingeWorthyOriginalsSection;
